var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#64596B",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.405 14.1993C17.9012 13.9231 17.2919 13.9353 16.7963 14.2278C16.3006 14.5203 16 15.0525 16 15.6253V30.5753C16 31.1481 16.3047 31.6803 16.7963 31.9728C17.2878 32.2653 17.9012 32.2775 18.405 32.0012L32.055 24.5262C32.575 24.2418 32.9 23.6934 32.9 23.1003C32.9 22.5071 32.575 21.9587 32.055 21.6743L18.405 14.1993Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d603eed7b7c02bad6c53350eec94b42c.svg";
export { ForwardRef as ReactComponent };